import React from 'react';
import {
  TextareaAutosize
} from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import './styles.scss';

const FormTextArea = ({
  title,
  name,
  validate,
  placeholder = 'Nhập...',
  type,
  className = 'form-control',
  titleClassName = 'text-dark',
  InputProps = {
    readOnly: false,
  },
  minRows = 3,
  ...rest
}) => {
  const { control, errors } = useFormContext();
  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={validate}
        placeholder={placeholder}
        render={({ onChange, name, onBlur, ref, value }) => (
          <>
            <label className={titleClassName}>
              {title}{validate?.required ? <span className='required'></span> : null}
            </label>
            <TextareaAutosize
              onChange={e => onChange(e)}
              placeholder={placeholder}
              value={value}
              ref={ref}
              onBlur={onBlur}
              name={name}
              minRows={minRows}
              className={className}
              InputProps={InputProps}
              {...rest} />
            {validate && errors[name] ? (
              <span className='error'>{errors[name] && errors[name].message}</span>
            ) : null}
          </>
        )
        }
      />
    </>
  );
};

export default FormTextArea;
